<template>
  <v-btn-toggle
    :value="value"
    mandatory
    dense
    color="deep-purple lighten-1"
    @change="$emit('input', $event)"
  >
    <v-btn v-for="audience in audiences" :key="audience" :value="audience">
      {{ $t(`surveys.audiences.${audience}`) }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { AUDIENCES } from '@/services/surveys.service';

export default {
  name: 'SurveyAudienceTabs',
  props: {
    value: { type: String, required: true },
  },
  data: () => ({
    audiences: AUDIENCES,
  }),
};
</script>
